export const imports = {
  'docs/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-index" */ 'docs/index.mdx'
    ),
  'docs/animations/AnimatedClipRect.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-animations-animated-clip-rect" */ 'docs/animations/AnimatedClipRect.mdx'
    ),
  'docs/api-reference/Overview.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-api-reference-overview" */ 'docs/api-reference/Overview.mdx'
    ),
  'docs/chart-settings/DataEncodings.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-chart-settings-data-encodings" */ 'docs/chart-settings/DataEncodings.mdx'
    ),
  'docs/chart-settings/Legend.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-chart-settings-legend" */ 'docs/chart-settings/Legend.mdx'
    ),
  'docs/chart-settings/Title.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-chart-settings-title" */ 'docs/chart-settings/Title.mdx'
    ),
  'docs/charts/BarChart.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-charts-bar-chart" */ 'docs/charts/BarChart.mdx'
    ),
  'docs/charts/LineChart.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-charts-line-chart" */ 'docs/charts/LineChart.mdx'
    ),
  'docs/graph-components/HeaderBox.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-graph-components-header-box" */ 'docs/graph-components/HeaderBox.mdx'
    ),
  'docs/graph-components/ResponsiveLayer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-graph-components-responsive-layer" */ 'docs/graph-components/ResponsiveLayer.mdx'
    ),
  'docs/graph-hooks/useContainerDimension.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-graph-hooks-use-container-dimension" */ 'docs/graph-hooks/useContainerDimension.mdx'
    ),
  'docs/themes/Theme.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-themes-theme" */ 'docs/themes/Theme.mdx'
    ),
}
